<template>
  <QTextField
    v-model.number="localValue"
    :label="label"
    :hint="hint"
    :persistentHint="!!hint"
    :rules="rules"
    :placeholder="definition.DefaultValue"
    type="number"
    externaledit
    clearable
  />
</template>

<script>
import QTextField from "@/components/Inputs/QTextField.vue";

export default {
  name: "QAIFieldDouble",
  components: { QTextField },
  props: {
    value: { type: [Number, String], default: null },
    definition: { type: Object, required: true },
  },
  computed: {
    localValue: {
      get() { return this.value; },
      set(v) {
        const parsed = parseFloat(v);
        this.$emit("input", isNaN(parsed) ? null : parsed);
      },
    },
    label() {
      return this.definition.Description || this.definition.Name;
    },
    hint() {
      return this.definition.DefaultValue ? `Default: ${this.definition.DefaultValue}` : "";
    },
    rules() {
      const r = [];
      if (this.definition.IsRequired) {
        r.push(v => (v !== null && v !== "" && v !== undefined) || `${this.definition.Name} is required`);
      }
      r.push(v => v === null || v === "" || !isNaN(Number(v)) || "Must be a number");
      return r;
    },
  },
};
</script>
